import { SurveyName } from '~/lib/constants/survey/SurveyName';

export const SurveyNameToListCardTitlesMap: Partial<
  Record<SurveyName, string[]>
> = {
  [SurveyName.NIAAA_BSTAD]: ['NIAAA', 'BSTAD', 'CRAFFT'],
  [SurveyName.C_SSRS_LIFETIME]: ['Lifetime', 'Past month'],
  [SurveyName.BAS]: ['Objective', 'Subjective'],
};
